export const DEFAULT_CHAT_MESSAGE = 'Здравствуйте! Заинтересовало ваше предложение. Пожалуйста, свяжитесь со мной';
